export default "__VITE_ASSET__Bke4uofB__"